/* eslint-disable complexity */
import { Pickable } from '@app/engine/core/interfaces';
import { keepTrackApi } from '@app/keepTrackApi';
import { ColorScheme } from './color-scheme';
import { html } from '@app/engine/utils/development/formatter';
export class OrbitalPlaneDensityColorScheme extends ColorScheme {
    label = 'Orbital Plane Density';
    id = 'OrbitalPlaneDensityColorScheme';
    static id = 'OrbitalPlaneDensityColorScheme';
    static uniqueObjectTypeFlags = {
        orbitalPlaneDensityHi: true,
        orbitalPlaneDensityMed: true,
        orbitalPlaneDensityLow: true,
        orbitalPlaneDensityOther: true,
    };
    static uniqueColorTheme = {
        orbitalPlaneDensityHi: [1.0, 0.0, 0.0, 1.0],
        orbitalPlaneDensityMed: [1.0, 0.5, 0.0, 1.0],
        orbitalPlaneDensityLow: [1.0, 1.0, 0.0, 1.0],
        orbitalPlaneDensityOther: [1.0, 1.0, 1.0, 0.3],
    };
    constructor() {
        super(OrbitalPlaneDensityColorScheme.uniqueColorTheme);
        this.objectTypeFlags = {
            ...this.objectTypeFlags, ...OrbitalPlaneDensityColorScheme.uniqueObjectTypeFlags,
        };
    }
    calculateParams() {
        const catalogManagerInstance = keepTrackApi.getCatalogManager();
        return {
            orbitalPlaneDensity: catalogManagerInstance.orbitalPlaneDensity,
            orbitalPlaneDensityMax: catalogManagerInstance.orbitalPlaneDensityMax,
        };
    }
    update(obj, params) {
        /*
         * NOSONAR
         * Hover and Select code might not pass params, so we will handle that here
         * TODO: Hover and select code should be refactored to pass params
         */
        if (!params) {
            const catalogManagerInstance = keepTrackApi.getCatalogManager();
            params = {
                orbitalPlaneDensity: catalogManagerInstance.orbitalPlaneDensity,
                orbitalPlaneDensityMax: catalogManagerInstance.orbitalPlaneDensityMax,
            };
        }
        if (obj.isStar()) {
            return this.starColor_(obj);
        }
        const checkFacility = this.checkFacility_(obj);
        if (checkFacility) {
            return checkFacility;
        }
        if (obj.isSensor()) {
            return {
                color: this.colorTheme.sensor,
                pickable: Pickable.Yes,
            };
        }
        if (obj.isMissile()) {
            return {
                color: this.colorTheme.transparent,
                pickable: Pickable.No,
            };
        }
        const sat = obj;
        const inc = Math.floor(sat.inclination / 2) * 2;
        const alt = Math.floor(((sat.apogee + sat.perigee) / 2) / 25) * 25;
        const orbitDensity = params.orbitalPlaneDensity[inc][alt];
        const density = orbitDensity / params.orbitalPlaneDensityMax;
        if (this.objectTypeFlags.orbitalPlaneDensityHi && density > 0.75) {
            return {
                color: settingsManager.colors.orbitalPlaneDensityHi ?? this.colorTheme.orbitalPlaneDensityHi,
                pickable: Pickable.Yes,
            };
        }
        else if (this.objectTypeFlags.orbitalPlaneDensityMed && density > 0.25) {
            return {
                color: settingsManager.colors.orbitalPlaneDensityMed ?? this.colorTheme.orbitalPlaneDensityMed,
                pickable: Pickable.Yes,
            };
        }
        else if (this.objectTypeFlags.orbitalPlaneDensityLow && density > 0.10) {
            return {
                color: settingsManager.colors.orbitalPlaneDensityLow ?? this.colorTheme.orbitalPlaneDensityLow,
                pickable: Pickable.Yes,
            };
        }
        else if (this.objectTypeFlags.orbitalPlaneDensityOther) {
            return {
                color: settingsManager.colors.orbitalPlaneDensityOther ?? this.colorTheme.orbitalPlaneDensityOther,
                pickable: Pickable.Yes,
            };
        }
        // Deselected
        return {
            color: this.colorTheme.deselected,
            pickable: Pickable.No,
        };
    }
    static layersHtml = html `
  <ul id="layers-list-orbitalPlaneDensity">
    <li>
      <div class="Square-Box layers-orbitalPlaneDensityHi-box"></div>
      High Orbit Density
    </li>
    <li>
      <div class="Square-Box layers-orbitalPlaneDensityMed-box"></div>
      Med Orbit Density
    </li>
    <li>
      <div class="Square-Box layers-orbitalPlaneDensityLow-box"></div>
      Low Orbit Density
    </li>
    <li>
      <div class="Square-Box layers-orbitalPlaneDensityOther-box"></div>
      Other Debris
    </li>
  </ul>
  `.trim();
}
